/**
 * A Claude Managed Agents webhook delivery to a hosted agent connection
 * (`POST /webhooks/managed-agents/:hub_id/:connection_id`, wayai-pro/wayai#5083 Phase 4).
 *
 * The body is vendor-authored and signature-verified, so it takes no schema here (AGENTS.md, API
 * Contracts): the route reads only its event type and the session id it names. These are the URL's
 * ids, the body cap and the answer.
 */
import { z } from 'zod';

/** The ids a delivery's URL names: the hub and its hosted agent connection, whose secret signs it. */
export const managedAgentsWebhookParams = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

/**
 * Largest delivery body accepted. A delivery carries only the event's type and ids (the vendor's
 * "thin" payload, a few hundred bytes); a larger one is refused before anything past the edge reads it.
 */
export const MANAGED_AGENTS_WEBHOOK_BODY_MAX_BYTES = 16 * 1024;

/** The answer to a verified delivery: whether it moved a waiting turn's next check to now. */
export interface ManagedAgentsWebhookResponse {
  ok: true;
  woke: boolean;
}
